import { render, staticRenderFns } from "./OrganizationDashboard.vue?vue&type=template&id=2b86fa76&scoped=true&"
import script from "./OrganizationDashboard.vue?vue&type=script&lang=js&"
export * from "./OrganizationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDashboard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrganizationDashboard.vue?vue&type=style&index=1&id=2b86fa76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b86fa76",
  null
  
)

export default component.exports